import { useDispatch } from "react-redux";
import { IconButton } from "../../components/IconButton";
import { lockScreen } from "../slices/lockScreenSlice";
const HeaderLockIcon = () => {
    const dispatch = useDispatch();
    const handleClick = () => dispatch(lockScreen());
    return (<IconButton type="font-awesome" onClick={handleClick} tooltip="Lock" identification="header-lock">
      lock
    </IconButton>);
};
export default HeaderLockIcon;
